/************  GESTION DE LA NAVIGATION *****************/

let lastScrollTop = 0;

jQuery( document ).ready( function( $ ) {
    setupNav();
    
    function setupNav() {
        // Fonction pour gérer la navigation
        $(window).scroll(showHideStickyMenu);
        $('.navigation .burger').click(showHideResponsiveMenu);
    }
    
    function showHideStickyMenu() {
        if ($(window).scrollTop() > 100) {
            $('.navigation').addClass('reduced');
            $('.navigation-surnav').slideUp(300);
        } else {
            $('.navigation').removeClass('reduced');
            $('.navigation-surnav').slideDown(300);
        }
        
        let st = $(this).scrollTop();
        if($(this).scrollTop() >= 1000 && st < lastScrollTop){
            $('.btn-topage').addClass('show');
        }else {
            $('.btn-topage').removeClass('show');
        }
        lastScrollTop = st;
    }
    
    // Fonction qui permet d'afficher/cacher le menu responsive
    function showHideResponsiveMenu() {
        if($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.fadebg').removeClass('show');
            $('.navigation .menu').removeClass('active');
            $('html, body').removeAttr('style');
        }else {
            $(this).addClass('active');
            $('.fadebg').addClass('show');
            $('.navigation .menu').addClass('active');
            $('html, body').css('overflow', 'hidden');
        }
    }
});


